// Only the first-party consent page supports our embedded approval flow.
// Other remote signers retain their normal external authorization behavior.
export function canEmbedApproval(value: string, bitcoinPlusPlusURL?: string): boolean {
  if (!bitcoinPlusPlusURL) return false;
  try {
    const url = new URL(value);
    const trusted = new URL(bitcoinPlusPlusURL);
    return url.origin === trusted.origin && url.pathname === '/signer/authorize'
      && !url.username && !url.password
      && (url.protocol === 'https:' || (url.protocol === 'http:' && url.hostname === 'localhost'));
  } catch {
    return false;
  }
}
